<template>
  <div>
    <select-base
      ref="base"
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :invalido="invalido"
      :require="requireGrupo"
      :label="label"
      :label-select="'nome'"
      :carregar="carregarGruposNotificacao"
      :filtro-adicional="filtroAdicional"
      :placeholder="placeholder"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
import api from '@/app-modulo/comuns/notificacao/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'GrupoNotificacaoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, Array],
      default: () => [],
    },
    label: {
      type: String,
      default: 'Grupo de Notificação',
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    placeholder: {
      type: String,
      default: 'Selecione um ou mais grupos',
    },
    requireGrupo: {
      type: Boolean,
      default: false,
    },
    apenasAtivos: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      internalValue: [],
      filtros: [
        {
          colunas: ['Nome'],
          valor: '',
          soletrado: true,
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.internalValue = value
      },
      get() {
        return this.internalValue
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarGruposNotificacao() {
      return api.getGruposNotificacoes(this.filtros, this.apenasAtivos)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
